import { usePrimaryCta } from '@mc/growth'
import { useStaticData } from '@mc/static-data-react'
import type { PrimaryCtaOverride } from 'libs/lcm/getLcmCtaOverride'

export const useCtaOverrideTrackProps = () => {
  const { ctaHref } = usePrimaryCta()
  const { primaryCtaOverride } = useStaticData<{
    primaryCtaOverride?: PrimaryCtaOverride | null
  }>()

  return primaryCtaOverride && primaryCtaOverride.href === ctaHref
    ? primaryCtaOverride.trackingProps
    : undefined
}
